import { trackEvent } from "./UtilsFunction";

export function ScrollEventForGa() {
    const arrivalTime = new Date();

  const deviceWidth = window.innerWidth;
  const deviceType = deviceWidth <= 768 ? "mobile" : "desktop";
   const time = arrivalTime.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  })
  const handleScroll = () => {
    const scrollTop = window.scrollY;
    const height = document.body.scrollHeight - window.innerHeight;
    const percent = (scrollTop / height) * 100;
 

    if (percent > 30 && !window._30Tracked) {
      window._30Tracked = true;
      trackEvent("scroll_30");
    }

    if (percent > 60 && !window._60Tracked) {
      window._60Tracked = true;
      trackEvent("scroll_60");
    }
  };

  window.addEventListener("scroll", handleScroll);

  const timer = setTimeout(() => {
    trackEvent("time_5s", {
      from: `${deviceWidth}-${deviceType}-${time}-${window.location.pathname}`,
      deviceWidth: `${deviceWidth}-${deviceType}-${time}`
    });
  }, 5000);

  // ✅ cleanup function
  return () => {
    window.removeEventListener("scroll", handleScroll);
    clearTimeout(timer);
  };
}